var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3294_6632)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 2,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2892 20.8554C19.9609 20.1999 19.283 19.75 18.5 19.75C17.3954 19.75 16.5 20.6454 16.5 21.75C16.5 22.8546 17.3954 23.75 18.5 23.75C19.283 23.75 19.9609 23.3001 20.2892 22.6446M20.2892 20.8554C20.4241 21.1246 20.5 21.4284 20.5 21.75C20.5 22.0716 20.4241 22.3754 20.2892 22.6446M20.2892 20.8554L28.7108 16.6446M20.2892 22.6446L28.7108 26.8554M28.7108 16.6446C29.0391 17.3001 29.717 17.75 30.5 17.75C31.6046 17.75 32.5 16.8546 32.5 15.75C32.5 14.6454 31.6046 13.75 30.5 13.75C29.3954 13.75 28.5 14.6454 28.5 15.75C28.5 16.0716 28.5759 16.3754 28.7108 16.6446ZM28.7108 26.8554C28.5759 27.1246 28.5 27.4284 28.5 27.75C28.5 28.8546 29.3954 29.75 30.5 29.75C31.6046 29.75 32.5 28.8546 32.5 27.75C32.5 26.6454 31.6046 25.75 30.5 25.75C29.717 25.75 29.0391 26.1999 28.7108 26.8554Z",
    stroke: "#758AF0",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3294_6632",
    x: 0.5,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.164706 0 0 0 0 0.258824 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3294_6632"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3294_6632",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.e2accde4779df7c0a2646cc4424243ba.svg";
export { ForwardRef as ReactComponent };